import React, { useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PDPOrderSwatchesSidebar from 'components/consumer/PDP/PDPOrderSwatchesSidebar';
import CtaButton from 'components/essentials/Cta/CtaButton';
import CtaLink from 'components/essentials/Cta/CtaLink';
import FinancingCtaButton from '../FinancingCtaButton';

const NewToggleCTALinkButton = props => {
  const { selected, ctaLink, ctaButton } = props;
  const CTAComponentType = selected;
  const [hover, setHover] = useState(false);
  const [isOrderSwatchesSidebarOpen, setIsOrderSwatchesSidebarOpen] = useState(
    false
  );
  const style = useMemo(() => {
    const styleObj = CTAComponentType === 'CTALink' ? ctaLink : ctaButton;
    return {
      ...(styleObj.color === 'custom' && {
        ...(styleObj.style === 'solid-button' && {
          background: {
            borderColor: styleObj.borderColor,
            backgroundColor: hover ? styleObj.hoverColor : styleObj.activeColor,
          },
        }),
        ...(styleObj.style === 'outline-button' && {
          background: {
            borderColor: styleObj.borderColor,
          },
        }),
        text: {
          color: styleObj.textColor,
        },
      }),
    };
  }, [CTAComponentType, hover, ctaLink, ctaButton]);
  let finalCTAButton = null;
  if (CTAComponentType === 'CTAButton' && ctaButton) {
    if (
      ctaButton.type &&
      (ctaButton.type === 'Affirm' || ctaButton.type === 'Financing')
    ) {
      finalCTAButton = (
        <FinancingCtaButton
          color={ctaButton.color || 'black'}
          styling={ctaButton.style || 'solid-button'}
          style={style}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {ctaButton.content}
        </FinancingCtaButton>
      );
    } else if (ctaButton.type && ctaButton.type === 'SwatchRequestForm') {
      finalCTAButton = (
        <CtaButton
          onClick={() => {
            setIsOrderSwatchesSidebarOpen(true);
          }}
          color={ctaButton.color || 'black'}
          styling={ctaButton.style || 'solid-button'}
          style={style}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {ctaButton.content}
        </CtaButton>
      );
    } else {
      finalCTAButton = (
        <CtaButton
          color={ctaButton.color || 'black'}
          styling={ctaButton.style || 'solid-button'}
          style={style}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {ctaButton.content}
        </CtaButton>
      );
    }
  }
  return (
    <>
      {isOrderSwatchesSidebarOpen && (
        <PDPOrderSwatchesSidebar
          show={isOrderSwatchesSidebarOpen}
          onClose={() => {
            setIsOrderSwatchesSidebarOpen(false);
          }}
          closeSlidePanel={() => {
            setIsOrderSwatchesSidebarOpen(false);
          }}
        />
      )}
      {CTAComponentType === 'CTALink' && ctaLink.content && (
        <div>
          <CtaLink
            to={ctaLink.linkTo}
            color={ctaLink.color}
            styling={ctaLink.style || 'solid-button'}
            style={style}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            {ctaLink.content}
          </CtaLink>
        </div>
      )}
      {CTAComponentType === 'CTAButton' && ctaButton?.content && (
        <div>{finalCTAButton}</div>
      )}
    </>
  );
};

export default withRouter(NewToggleCTALinkButton);
